import { motion } from "framer-motion";
import { FadeIn, StaggeredGrid } from "@/components/animated";
import { guarantees } from "@/data/homePageData";
import {
  Shield,
  Infinity,
  Award,
  Headphones,
  CheckCircle2,
} from "lucide-react";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  Shield: Shield,
  Infinity: Infinity,
  Award: Award,
  Headphones: Headphones,
};

export function GuaranteesSection() {
  return (
    <section className="py-16 bg-secondary-50">
      <div className="container">
        <FadeIn>
          <div className="text-center mb-12">
            <h2 className="font-display text-2xl md:text-3xl font-bold text-secondary-900 mb-3">
              Aprendes con tranquilidad
            </h2>
            <p className="text-secondary-600">
              Tu satisfacción es nuestra prioridad
            </p>
          </div>
        </FadeIn>

        <StaggeredGrid
          className="grid grid-cols-2 lg:grid-cols-4 gap-6"
          staggerDelay={0.1}
        >
          {guarantees.map((guarantee) => {
            const Icon = iconMap[guarantee.icon] || CheckCircle2;
            return (
              <motion.div
                key={guarantee.id}
                whileHover={{ scale: 1.02 }}
                className="bg-white rounded-2xl p-6 text-center shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-success-100 text-success-600 mb-4">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-semibold text-secondary-900 mb-1">
                  {guarantee.title}
                </h3>
                <p className="text-sm text-secondary-500">
                  {guarantee.description}
                </p>
              </motion.div>
            );
          })}
        </StaggeredGrid>
      </div>
    </section>
  );
}
